module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("音频后期处理")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Adobe Audition（AA）录音及简单后期制作")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_15.png")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_16.png")
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_17.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        2、选择录音轨道：选择轨道2的红色R键 （见下图），将你的人声录制在第二条轨道，然后在弹出的对话框里保存将要录制的歌曲会话。\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_18.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        3、点左下角红色录音键，跟随伴奏开始演唱录音（见下图）\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_19.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        4、录完之后点左下角播放键试听（见下图），看有没有唱错的地方，是否需要重新录制。\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_20.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        5、选中音轨2，点左上方的“编辑”进入单轨编辑界面（见下图）\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_21.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        6、将你录制的原始人声文件保存为mp3格式，当然也可以存为wma,更能节省空间。到这里录音部分的工作就完成了（见下图）\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_22.png")
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_23.png")
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_24.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        混缩：把伴奏和人声进行混缩（打开编辑→合并到新音轨→所选范围的音频剪辑（立体声））得到新的音轨“混缩”（见下图）\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "430px",
      "height": "300px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_25.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        完成了，保存就OK啦\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("软件下载：")]), _vm._v(" "), _c('br'), _vm._v("1：关于Adobe Audition的介绍和正版软件下载，"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.adobe.com/cn/"
    }
  }, [_vm._v("请点击这里进入Adobe官网了解 >>>")]), _vm._v(" "), _c('br'), _vm._v("2：你也可以通过网络搜索其它渠道下载试用。\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("安装录音软件及插件")]), _vm._v("\n        首先按提示装好录音软件及插件，然后打开录音软件点左上角的编辑按钮进入编辑状态 见下图\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("启用插件：")]), _vm._v(" "), _c('br'), _vm._v("刷新效果列表（效果→刷新效果列表），然后启用DirextX效果（效果→启用DirextX效果）见下图\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("打开软件开始录歌")]), _vm._v(" "), _c('br'), _vm._v("1、插入伴奏：（打开插入→音频），选择下载到电脑里的伴奏（见下图）\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        PS：录音的时候要关闭音箱，通过耳机听伴奏，伴奏的音量避免过大，否则容易把伴奏也录进人声里，这样会导致声音听起来不够清晰。麦克的音量也不能太大，不能超过总音量的大小，略小一些为佳，如果麦克音量过大，会导致录出的波形成了方波，这种波形的声音是失真的，也不能用，无论唱的多好，也不可能处理出好的结果，这一点很重要，录制的时候一定要看波形的动态。\n        "), _c('br'), _c('br'), _vm._v("下面介绍下简单的后期制作\n        "), _c('br'), _c('br'), _c('strong', [_vm._v("首先是降噪：")]), _vm._v(" "), _c('br'), _vm._v("选取一段没有人声的录音进行采样 见下图然后双击整个波形，进行降噪 见下图，降噪要有耐心，一次降噪的值不能太大，否则会失真，我都在20%以内，如果噪音太大可以用低值反复降，这样出来的效果要比用高值一次降出来的效果好，在降噪的过程中一边降一边听，有一点噪音不要紧，伴奏会遮挡住的。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d045372!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/AudioPostProgress.vue
// module id = 371
// module chunks = 0